import { createComponents } from "./createComponents";
import { createPalette } from "./createPalette";
import { createShadows } from "./createShadows";

export const createOptions = ({ colorPreset, contrast }) => {
  const palette = createPalette({ colorPreset, contrast });
  const components = createComponents({ palette });
  const shadows = createShadows();

  return {
    components,
    palette,
    shadows,
  };
};
